import React from "react";

const TantanganUIUXEraAI: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Keluhan mengenai aplikasi yang membingungkan, tombol sulit digunakan,
        atau fitur yang tidak intuitif masih sering ditemui di era digital.
        Pengalaman UI/UX yang buruk kerap membuat pengguna merasa frustasi dan
        enggan menggunakan aplikasi kembali. Hal ini menegaskan bahwa desain
        UI/UX tidak hanya berfungsi sebagai elemen visual, tetapi juga sebagai
        jembatan utama antara teknologi dan kebutuhan pengguna. Memahami
        preferensi pengguna yang beragam menjadi salah satu{" "}
        <a 
        href="https://www.codepolitan.com/blog/mengenal-uiux-adalah-pentingnya-desain-digital-industri-modern"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline font-medium"
        >
        tantangan utama dalam perancangan UI/UX
        </a>
        , agar desain mampu menyeimbangkan fungsi,
        estetika, dan kenyamanan penggunaan.
      </p>

      <p>
        Memasuki era kecerdasan buatan (AI), tantangan UI/UX semakin kompleks.
        Desain tidak lagi sekadar menyajikan antarmuka menarik, tetapi juga harus
        mampu mengakomodasi interaksi dengan sistem berbasis AI, otomasi, dan{" "}
        <a 
        href="https://socs.binus.ac.id/2025/10/15/meningkatkan-pengalaman-pengguna-ux-ui-dengan-generative-ai" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="text-blue-600 underline font-medium">
          teknologi generatif
        </a>
        . AI memungkinkan personalisasi pengalaman pengguna
        melalui analisis data secara real-time, namun kompleksitas teknologi ini
        sering kali sulit dipahami oleh pengguna umum jika tidak dirancang
        dengan pendekatan yang tepat.
      </p>

      <p>
        Salah satu tantangan utama UI/UX modern adalah menyederhanakan
        fitur-fitur canggih agar tetap intuitif. Rekomendasi otomatis atau
        antarmuka adaptif berbasis AI perlu disajikan secara jelas dan mudah
        dipahami oleh berbagai kalangan pengguna. Tanpa perancangan yang matang,
        fitur tersebut justru dapat terasa membingungkan, berlebihan, atau
        mengurangi rasa percaya pengguna terhadap aplikasi.
      </p>

      <p>
        Tantangan lainnya adalah menjaga keseimbangan antara inovasi dan
        kenyamanan. Di tengah perubahan tren desain dan teknologi yang cepat,
        desainer dituntut menciptakan pengalaman yang konsisten di berbagai
        platform. Proses ini membutuhkan riset mendalam, pengujian berulang,
        serta iterasi desain berkelanjutan agar teknologi yang digunakan
        benar-benar berorientasi pada kebutuhan manusia, bukan sekadar
        menampilkan kecanggihan.
      </p>

      <p>
        Pemahaman atas tantangan tersebut mendorong pendekatan desain UI/UX yang
        lebih strategis dan berbasis pengguna, seperti yang diangkat dalam
        kompetisi{" "}
        <strong>Obstacle for Creating UI/UX Mobile Application</strong>.
        Kompetisi ini mendorong peserta untuk merancang solusi UI/UX yang
        aplikatif, fungsional, dan relevan di era AI. Didukung oleh Indonesia Innovative Technology (IIT) 
        bersama{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , ajang ini menjadi wadah pengembangan talenta digital agar siap menghadapi tantangan desain dan teknologi masa depan.
      </p>

      <p className="font-medium">
        👉 Cek untuk informasi lomba <span className="text-blue-600">Obstacle for Creating UI/UX Mobile Application</span> lebih lanjut.
      </p>
    </div>
  );
};

export default TantanganUIUXEraAI;
